module.exports = {
	extends: [
		'/',
		'templates',
		'artForm',
		'entity',
		'propertiesForm'
	],

	config: {
		contextClass: false
	},

	model: {
		changesGranted: false
	},

	methods: {

		onSubmit: function(response){
			var entityData = response.data || {};

			return getComponent('artFormController').showEdit(
				'address',
				entityData.attributes[entityData.primaryKey || 'id'],
				entityData,
				true,
				this.model.recordController.model.tabStrip,
				this.model.recordController.model.tabRegisterSecret
			);
		},
	},

	hooks: {
		_attach: function($element, options){
			this.model.changesGranted = true;
		}
	}
}